import React from 'react';
// component
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const navConfig = [
  {
    title: 'Bookings',
    path: '/dashboard/bookings',
    icon: getIcon('mdi:ticket'),
    role: { read: true },
    module: 'bookingsModule',
  },
  {
    title: 'Passes',
    path: '/dashboard/passes',
    icon: getIcon('mdi:ticket-confirmation'),
    role: { read: true },
    module: 'passesModule',
  },
  {
    title: 'Promo Codes',
    path: '/dashboard/promoCodes',
    icon: getIcon('mdi:tag'),
    role: { read: true },
    module: 'promoCodesModule',
  },
  {
    title: 'Drivers',
    path: '/dashboard/drivers',
    icon: getIcon('mdi:card-account-details'),
    role: { read: true },
    module: 'driversModule',
  },
  {
    title: 'Vehicles',
    path: '/dashboard/vehicles',
    icon: getIcon('mdi:van-passenger'),
    role: { read: true },
    module: 'vehiclesModule',
  },
  {
    title: 'Admin Users',
    path: '/dashboard/users',
    icon: getIcon('mdi:van-passenger'),
    module: 'usersModule',
    restrictedToRole: [900, 101],
  },
  {
    title: 'E-KYC Verification',
    path: '/dashboard/verification',
    icon: getIcon('mdi:shield-check'),
    role: { read: true },
    module: 'verificationModule',
    restrictedToRole: [900, 101],
  },
  {
    title: 'Driver Scheduling',
    path: '/dashboard/scheduling',
    icon: getIcon('mdi:car-wrench'),
    role: { read: true },
    module: 'schedulingModule',
  },
  {
    title: 'Notifications Campaign',
    path: '/dashboard/notifications',
    icon: getIcon('mdi:bell-outline'),
    role: { read: true },
    module: 'notificationsModule',
  },
  {
    title: 'Operator',
    path: '/dashboard/operators',
    icon: getIcon('mdi:car-wrench'),
    role: { read: true },
    module: 'operatorsModule',
    restrictedToRole: [900, 101],
  },
];

export default navConfig;
